import FolderTabs from './FolderTabs';

export * from './types';

export default FolderTabs;
